import * as React from 'react';
import {
  Container, Divider, Card, Box, Typography, Link
} from '@mui/material'

import PageWrapper from 'components/PageWrapper';
import { H2HSelect } from 'pages/main/components/ActivityCard';
import { H2HHeader } from 'pages/main/components/ActivityCard';
import { useHead2Head } from 'assets/utils';
import { H2HFullSummary } from 'pages/main/components/ActivityCard';
import { SearchPlayerDialog } from 'pages/main/components/ActivityCard';
import { H2HInfo } from 'pages/main/components/ActivityCard';
import { useTranslation } from "react-i18next";
import PageWrapperBox from 'components/PageWrapperBox';

export default function SimulationPage() {

    const { t } = useTranslation();

    return <PageWrapper>
            <PageWrapperBox>
            <Typography variant="h6" fontWeight="bold" color="primary" component="div">
                {t("simulate.title")}
            </Typography>
            

            <Typography variant="body" fontWeight="light" component="div" >
                {t("simulate.subtitle")}
            </Typography>
            </PageWrapperBox> 

            <Simulation />
    </PageWrapper>
}

function Simulation() {
    const [searchDialogMode, setSearchDialogMode] = React.useState(0); // 0 = none, 1 = search 11, 1 = search 12, 2 = search 21, 3 = search 22
      
    const [myPlayer, setMyPlayer] = React.useState(null);
    const [opponentPlayer, setOpponentPlayer] = React.useState(null);
    const [partnerPlayer, setPartnerPlayer] = React.useState(null);
    const [opponentPartnerPlayer, setOpponentPartnerPlayer] = React.useState(null);

    const data = useHead2Head(myPlayer?.id, opponentPlayer?.id, partnerPlayer?.id, opponentPartnerPlayer?.id);

    return <Box sx={{pt: 3}}>

        
        <H2HHeader 
            data={data} 
            myId={myPlayer?.id} 
            myName={myPlayer?.name}
            myPts={myPlayer?.padel_pts}
            myClub={myPlayer?.name_club}
            partnerId={partnerPlayer?.id} 
            opponentId={opponentPlayer?.id} 
            opponentName={opponentPlayer?.name}
            opponentPts={opponentPlayer?.padel_pts}
            opponentClub={opponentPlayer?.name_club}
            opponentPartnerId={opponentPartnerPlayer?.id} />

        <Divider sx={{my: 2}}/>
        
        <H2HSelect data={data} setSearchDialogMode={setSearchDialogMode} />
        
        <Divider sx={{my: 2}}/>
        {data ? <H2HFullSummary data={data} /> : null}
        
        <H2HInfo />
        
        <SearchPlayerDialog mode={searchDialogMode} onClickPlayer={(player) => {
            if (searchDialogMode === 1 && player) {
            setMyPlayer(player);
            } else if (searchDialogMode === 2 && player) {
            setOpponentPlayer(player);
            } else if (searchDialogMode === 3) {
            setPartnerPlayer(player);
            } else if (searchDialogMode === 4) {
            setOpponentPartnerPlayer(player);
            }
            setSearchDialogMode(0);
        }} />
    </Box>

}